<template>
  <div class="container mx-auto px-6 h-screen flex flex-col items-center">
    <div v-if="showForm" class="flex-1 mb-auto flex flex-col items-center justify-center">
      <h1 class="font-roboto-slab text-white md:text-6xl text-5xl text-center leading-tight mb-6">Mis on sinu sõdurinimi?</h1>
      <p class="text-white text-center mb-12 text-lg">Sisesta oma ees- ja perekonnanimi, vajuta nupule ja saad teada!</p>
      <form class="sm:flex block items-stretch justify-center sm:w-auto w-full" @submit="generateName">
        <div class="bg-white sm:w-auto w-full rounded-lg px-3 pt-4 pb-2 sm:mx-2 mx-0 sm:mb-0 mb-4">
          <div class="relative">
            <input type="text" v-model="fname" id="fname" class="appearance-none focus:outline-none mt-2 sm:w-auto w-full" maxlength="17" placeholder=" " :disabled="loading" required />
            <label for="fname" class="absolute top-0 left-0 duration-300 origin-0 text-gray-500">Eesnimi</label>
          </div>
        </div>
        <div class="bg-white sm:w-auto w-full rounded-lg px-3 pt-4 pb-2 sm:mx-2 mx-0 sm:mb-0 mb-4">
          <div class="relative">
            <input type="text" v-model="lname" id="lname" class="appearance-none focus:outline-none mt-2 sm:w-auto w-full" maxlength="17" placeholder=" " :disabled="loading" required />
            <label for="lname" class="absolute top-0 left-0 duration-300 origin-0 text-gray-500">Perekonnanimi</label>
          </div>
        </div>
        <template v-if="loading">
          <button class="flex items-center justify-center bg-brand-500 rounded-lg px-6 font-bold text-white sm:mx-2 mx-0 sm:w-auto w-full sm:py-0 py-4 text-xl hover:bg-brand-600" disabled>
            <svg class="animate-spin mr-2 h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span class="font-medium text-lg">Palun oodake...</span>
          </button>
        </template>
        <template v-else>
          <button type="submit" class="bg-brand-500 rounded-lg px-10 font-bold text-white sm:mx-2 mx-0 sm:w-auto w-full sm:py-0 py-4 text-xl hover:bg-brand-400 active:bg-brand-600">Anna tuld</button>
        </template>
      </form>
    </div>
    <div v-else class="flex-1 mb-auto flex flex-col items-center justify-center">
      <h1 class="font-roboto-slab text-white md:text-6xl text-5xl text-center leading-tight mb-8">Sinu sõdurinimi on:</h1>
      <div class="bg-brand-500 px-10 py-6 rounded-xl font-roboto-slab text-white text-4xl mb-12 text-center">
        {{name}}
      </div>
      <template v-if="loading">
        <button class="flex bg-white rounded-lg px-4 py-2 items-center" @click="share" :disabled="loading">
          <svg class="animate-spin mr-2 h-10 w-10 text-brand-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="font-medium text-lg">Palun oodake...</span>
        </button>
      </template>
      <template v-else-if="shareUrl">
        <div class="text-white text-center">
          <div class="text-sm mb-1">Kui oled hüpikaknad blokeerinud, saad sõpradega jagada seda linki:</div>
          <div class="font-semibold">{{shareUrl}}</div>
        </div>
      </template>
      <template v-else>
        <button class="flex bg-white rounded-lg px-4 py-2 items-center" @click="share" :disabled="loading">
          <svg class="h-10 w-10 fill-current text-brand-500 mr-2" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 167.657 167.657" xml:space="preserve">
            <g>
              <path d="M83.829,0.349C37.532,0.349,0,37.881,0,84.178c0,41.523,30.222,75.911,69.848,82.57v-65.081H49.626
                v-23.42h20.222V60.978c0-20.037,12.238-30.956,30.115-30.956c8.562,0,15.92,0.638,18.056,0.919v20.944l-12.399,0.006
                c-9.72,0-11.594,4.618-11.594,11.397v14.947h23.193l-3.025,23.42H94.026v65.653c41.476-5.048,73.631-40.312,73.631-83.154
                C167.657,37.881,130.125,0.349,83.829,0.349z"/>
            </g>
          </svg>
          <span class="font-medium text-lg">Jaga sõpradega</span>
        </button>
      </template>
      <div class="flex mt-8 items-center justify-center">
        <button @click="generateName" class="text-white text-xs uppercase tracking-wide focus:outline-none">Proovi veel</button> <span class="text-brand-500 mx-2">•</span> <button @click="reset" class="text-white text-xs uppercase tracking-wide focus:outline-none">Avalehele</button>
      </div>
    </div>
    <div class="text-white text-center mb-8 text-sm text-gray-400 max-w-2xl mx-auto">Sõdurinimegeneraatori veebilehe kasutajaid ei tuvastata ja samalt IP-aadressilt tulnud erinevaid veebilehekülastusi profileerimiseks kokku ei viida.</div>
  </div>
</template>

<script>
import axios from 'axios'
import { postsCollection } from '../../config/firebase'
export default {
  name: 'Home',
  props: {
    id: String
  },
  data () {
    return {
      fname: '',
      lname: '',
      image: '',
      name: '',
      uid: '',
      loading: false,
      showForm: true,
      shareUrl: ''
    }
  },
  mounted() {
    if (this.id) {
      this.loading = true
      postsCollection.doc(this.id).get()
      .then(doc => {
        if (doc.exists) {
          this.loading = false
          const results = doc.data()
          this.image = results.image
          this.name = results.name
        }
        this.loading = false
        this.showForm = true
      })
      .catch(err => {
        console.log('Error getting document', err)
      })
    }
  },
  metaInfo () {
    return {
      title: (this.name) ? 'Minu sõdurinimi on ' + this.name : 'Mis on sinu sõdurinimi?',
      meta: [
        {charset: 'utf-8'},
        {name: 'viewport', content: 'width=device-width, initial-scale=1'},
        {
          key: 'og:title',
          property: 'og:title',
          content: (this.name) ? 'Minu sõdurinimi on ' + this.name : 'Mis on sinu sõdurinimi? '
        },
        {
          key: 'og:description',
          property: 'og:description',
          content: (this.name) ? 'Proovi ka, äkki saad endale veel ägedama!' : 'Väge täis sõdurinimed ei ole ainult filmikangelaste jaoks – kliki lingile ja saad endale ka!'
        },
        {
          name: 'image',
          key: 'og:image',
          property: 'og:image',
          content: (this.image) ? this.image : process.env.VUE_APP_BASE_URL+'defaultOG.png'
        },
        {
          key: 'og:image:type',
          property: 'og:image:type',
          content: (this.image) ? 'jpeg' : 'png'
        },
        {
          key: 'og:image:width',
          property: 'og:image:width',
          content: '1200px'
        },
        {
          key: 'og:image:height',
          property: 'og:image:height',
          content: '628px'
        },
        {
          key: 'og:type',
          property: 'og:type',
          content: 'website'
        },
        {
          key: 'fb:app_id',
          property: 'fb:app_id',
          content: '656371908397150'
        },
        {
          key: 'og:url',
          property: 'og:url',
          content: (this.id) ? process.env.VUE_APP_BASE_URL+'share/'+this.id : process.env.VUE_APP_BASE_URL
        },
      ]
    }
  },
  methods: {
    reset () {
      this.image = ''
      this.name = ''
      this.uid = ''
      this.loading = false
      this.showForm = true
      this.shareUrl = ''
    },
    capFirst(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    },
    getRandomName(fname, lname, names) {
      const firstNameLetter = fname.charAt(0).toLowerCase()
      const lastNameLetter = lname.charAt(0).toLowerCase()
      const results = names.filter(n => n.charAt(0).toLowerCase() === firstNameLetter || n.charAt(0).toLowerCase() === lastNameLetter)
      if (results && results.length > 0) {
        return this.capFirst(results[this.getRandomInt(0, results.length)])
      } else {
        return this.capFirst(names[this.getRandomInt(0, names.length)])
      }
    },
    async share () {
      this.shareUrl = ''
      this.loading = true
      await this.getImage(this.name)
      await postsCollection
        .doc(this.uid)
        .set({
          image: this.image,
          name: this.name
        }).then(() => {
          // eslint-disable-next-line no-undef
          FB.ui({
            method: 'share',
            href: process.env.VUE_APP_BASE_URL+'share/'+this.uid
          }, () => {
            this.loading = false
          })
        }).catch(() => {
          this.loading = false
          this.showForm = false

        })
      this.loading = false
    },
    async generateName (e) {
      e.preventDefault()
      this.shareUrl = ''
      this.loading = true
      this.name = ''
      this.image = ''
      const name1 = ['alligaator', 'anakonda', 'android', 'armageddon', 'automaat', 'dessant', 'dingo', 'draakon', 'dünamiit', 'elajas', 'elukas', 'fantoom', 'geko', 'gepard', 'gerilja', 'godzilla', 'gorilla', 'granaat', 'greif', 'hai', 'haubits', 'herilane', 'hoop', 'hunt', 'härg', 'hävitaja', 'jaaguar', 'jeekim', 'jõud', 'jäämees', 'kaamos', 'kahur', 'kahurikuul', 'kaliiber', 'kambajõmm', 'kamikaze', 'kamraad', 'kangelane', 'karu', 'kauboi', 'keeristorm', 'keravälk', 'kihv', 'kiiver', 'kilp', 'king kong', 'kiskja', 'kobra', 'kolonn', 'komando', 'komeet', 'kondor', 'konflikt', 'konvoi', 'kopter', 'košmaar', 'kotkas', 'krokodill', 'kullipilk', 'kummitus', 'kuriloom', 'kurivaim', 'kuul', 'kuulirahe', 'kõu', 'kõuemürin', 'kõuepilv', 'kärgatus', 'käsk', 'küborg', 'küte', 'laava', 'laeng', 'lammutaja', 'laser', 'laskur', 'leegion', 'leek', 'legend', 'leopard', 'loom', 'luuraja', 'lõhkepea', 'lõvi', 'lõõm', 'löök', 'lööklaine', 'lööming', 'madu', 'mahtra', 'maniakk', 'manööver', 'masin', 'matšeete', 'metsaline', 'metslane', 'miin', 'miiniväli', 'monster', 'murdja', 'mõõk', 'märklaud', 'möll', 'mürgel', 'mürin', 'müristaja', 'mürkmadu', 'mürsk', 'mürts', 'ninja', 'nokaut', 'nuga', 'nui', 'obadus', 'oda', 'oht', 'oomen', 'orkaan', 'padrun', 'pahandus', 'paharet', 'panter', 'paraad', 'patrull', 'pealik', 'pettekas', 'pikne', 'piraaja', 'pistoda', 'pistrik', 'plahvatus', 'pomm', 'pommitaja', 'predaator', 'pull', 'purustaja', 'purustus', 'puuma', 'põrguingel', 'põrguline', 'päästik', 'püss', 'püssirohi', 'püüton', 'radar', 'rahe', 'raju', 'rakett', 'rambo', 'ratsavägi', 'raudmees', 'raudrüü', 'rebane', 'relvavend', 'robot', 'ronk', 'rusikas', 'rästik', 'rügement', 'rünnak', 'saadanas', 'saatus', 'salarelv', 'samurai', 'sangar', 'sarvik', 'sensor', 'sihik', 'sissetung', 'skorpion', 'soomuk', 'sorts', 'sparta', 'spartalane', 'spetsialist', 'splint', 'susi', 'suurtükk', 'sõdalane', 'sõjakirves', 'sõjamasin', 'sõjapealik', 'sõjaratsu', 'sööst', 'sütik', 'šaakal', 'tabamus', 'taktik', 'tank', 'tapleja', 'taplus', 'tapper', 'tarvas', 'tasuja', 'teras', 'terasmees', 'terminaator', 'tiiger', 'titaan', 'tomahook', 'tont', 'torm', 'tormilind', 'tormipilv', 'tornaado', 'torpeedo', 'tuisk', 'tulejoon', 'tulejutt', 'tulejõud', 'tulevärk', 'turmtuli', 'tuul', 'tuulispask', 'täistabamus', 'tärin', 'ultimaatum', 'valang', 'valgusmõõk', 'vanakaval', 'varaan', 'vari', 'vasar', 'vastulöök', 'vastupanu', 'vendetta', 'vibukütt', 'viiking', 'võitja', 'väelane', 'vägi', 'vägilane', 'välk', 'õudukas', 'äike', 'äikesepilv', 'äss', 'öö', 'üksus']
      const name2 = ['hiiliv', 'hull', 'huugav', 'jooksev', 'jäine', 'jääkülm', 'kappav', 'karm', 'kartmatu', 'kaval', 'kihutav', 'kiire', 'kirevane', 'kivine', 'kriipiv', 'krõbe', 'kuri', 'kuum', 'kõva', 'käre', 'külm', 'laetud', 'laiguline', 'lendav', 'luurav', 'lähenev', 'magav', 'marssiv', 'maruline', 'meeletu', 'möirgav', 'mürisev', 'müristav', 'nobe', 'nähtamatu', 'ohtlik', 'paukuv', 'peidus', 'pimestav', 'raevukas', 'raevunud', 'raju', 'raske', 'raudne', 'salakaval', 'salalik', 'salvav', 'segane', 'siuglev', 'terav', 'tige', 'tontlik', 'tormav', 'tormine', 'trampiv', 'tugev', 'tuleohtlik', 'tuline', 'tuus', 'tõhus', 'uljas', 'urisev', 'vaikne', 'valus', 'vapper', 'varitsev', 'veiklev', 'vihisev', 'visa', 'väle', 'välkuv']
      const name3 = ['alarm', 'banzai', 'detonaator', 'epitsenter', 'halbus', 'hasta la Vista', 'hulljulge', 'jääkülm', 'kahjuraport', 'kange', 'kangelane', 'kartmatu', 'kirevane', 'krüpto', 'kuramus', 'kuul Rauas', 'kuulikindel', 'käed Üles', 'laetud', 'laetud Relv', 'lahingmoon', 'lahinguvalmis', 'laiguline', 'maa-Õhk', 'madallend', 'magnetmiin', 'majakas', 'manööver', 'meeletu', 'nähtamatu', 'ohutsoon', 'okastraat', 'otsetuli', 'plahavatuslik', 'plahvatusohtlik', 'platsdarm', 'polügoon', 'püha Püss', 'raju', 'rindejoon', 'salaoperatsioon', 'sangar', 'sayonara', 'seire', 'skalp', 'splint', 'staap', 'suur Tõll', 'švejk', 'thor', 'tulejoon', 'tuleohtlik', 'turvatsoon', 'tuus', 'tähesõjad', 'ultra', 'vaba Tuli', 'vahva Sõdur', 'valhalla', 'van Damme', 'varioperatsioon', 'visa Hing', 'võitlusvalmis', 'võitmatu', 'väle', 'õnneseen', 'äkkrünnak']
      const nameType = Math.floor(Math.random() * 3) + 1
      if (nameType === 1) {
        this.name = this.capFirst(this.fname) + ' "' + this.getRandomName(this.fname, this.lname, name1) + '" ' + this.capFirst(this.lname)
      } else if (nameType === 2) {
        this.name = this.capFirst(this.fname) + ' "' + this.getRandomName(this.fname, this.lname, name2) + ' ' + this.capFirst(name1[this.getRandomInt(0, name1.length)]) + '" ' + this.capFirst(this.lname)
      } else {
        this.name = this.capFirst(this.fname) + ' "' + this.getRandomName(this.fname, this.lname, name3) + '" ' + this.capFirst(this.lname)
      }
      this.showForm = false
      this.loading = false
    },
    async getImage(name) {
      await axios.get('/.netlify/functions/screenshot?name=' + name)
      .then((response) => {
        if (response.data.status === 'success') {
          this.image = process.env.VUE_APP_SPACES_URL + response.data.fileName
          this.uid = response.data.uid
          this.shareUrl = process.env.VUE_APP_BASE_URL+'share/'+this.uid
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss">
  input:focus-within ~ label,
  input:not(:placeholder-shown) ~ label {
    @apply transform scale-75 -translate-y-3;
  }
</style>
